import { Component, inject } from '@angular/core';
import { BaseAppComponent } from '@pf/shared/ui-app-shared';
import { IS_CT_WEB_VIEW } from '@pf/shared/ui-platform';
import { AppRouter } from './app.routes';

@Component({
    selector: 'cpw-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false,
})
export class AppComponent extends BaseAppComponent {
    override title = 'Control Tower - CPW';
    override appRouter = inject(AppRouter);
    private readonly isWebView = inject(IS_CT_WEB_VIEW);

    constructor() {
        super();

        this.layoutService.isHidden = true;
        //this.layoutService.setPullDownRefreshEnabled(!!window.CT_Native_AppBar);
        this.layoutService.setPullDownRefreshEnabled(true);
    }
}
